var _style, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogoImage({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 55 31",
    style: {
      enableBackground: "new 0 0 55 31"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n    .st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M54.9,29.3L45.7,1.2c-0.1-0.4-0.5-0.7-1-0.7h-4.3c-0.4,0-0.8,0.3-1,0.7l-9.2,28.1c-0.1,0.3,0,0.7,0.1,0.9     c0.2,0.3,0.5,0.4,0.8,0.4h3.6c0.4,0,0.8-0.3,1-0.7l2.1-6.5h9.4l2.1,6.5c0.1,0.4,0.5,0.7,1,0.7H54c0.3,0,0.6-0.2,0.8-0.4     C55,29.9,55.1,29.6,54.9,29.3z M39.5,18l3-9.5l3,9.5H39.5z M27.6,1.1v29c0,0.3-0.2,0.5-0.5,0.5c-0.3,0-0.5-0.2-0.5-0.5v-29     c0-0.3,0.2-0.5,0.5-0.5C27.4,0.5,27.6,0.8,27.6,1.1z M23.1,21.8c0,2.4-0.9,4.5-2.6,6.2c-2,2-5.1,3-8.6,3c-3.6,0-6.5-1-8.6-2.9     C1.2,26.2,0,23.4,0,20.6c0-0.6,0.5-1,1-1h3.7c0.6,0,1,0.5,1,1c0,1.3,0.6,2.7,1.6,3.7c0.9,0.9,2.5,1.4,4.5,1.4c2,0,3.5-0.4,4.4-1.3     c0.8-0.7,1.1-1.5,1.1-2.5c0-1.9-1.3-3.1-3.7-3.5l-4.3-0.7c-5.2-0.8-8.2-3.9-8.2-8.4c0-2.4,1-4.6,2.7-6.3c2.1-2,4.8-3,7.9-3     c3.1,0,5.9,1,7.9,2.9c1.9,1.8,2.9,4.1,3,6.7c0,0.3-0.1,0.5-0.3,0.7c-0.2,0.2-0.5,0.3-0.7,0.3h-3.7c-0.5,0-1-0.4-1-1     c-0.1-1.1-0.4-2.1-1.1-2.8c-0.9-1.1-2.3-1.6-4.1-1.6c-1.8,0-3.1,0.5-4.1,1.6C7,7.6,6.8,8.2,6.8,9.2c0,2.2,2,2.8,3.2,2.9     c1,0.1,2,0.3,2.9,0.4l1.6,0.3C19.8,13.6,23.1,17,23.1,21.8z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoImage);
export default __webpack_public_path__ + "static/media/LogoImage.d6d7c984.svg";
export { ForwardRef as ReactComponent };